export const TOGGLE_MENU_VISIBILITY = 'TOGGLE_MENU_VISIBILITY';
export const CLOSE_MENU = 'CLOSE_MENU';
